import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ExportClientsTool from './ExportClientsTool';
import './Tools.scss';

const Tools = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className="py-4">
      <h1 className="h3 mb-4">{t('tools.title')}</h1>
      
      <Row className="g-4">
        <Col md={4}>
          <ExportClientsTool />
        </Col>
      </Row>
    </Container>
  );
};

export default Tools; 